/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiCrossReferenceOrderType.ts    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-cross-reference-order-type";

export class AutogenModelEdiCrossReferenceOrderType<RowType extends ModelRow> extends Endpoint<RowType, RowEdiCrossReferenceOrderTypeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiCrossReferenceOrderType extends ModelRow<RowEdiCrossReferenceOrderTypeFields> {
	constructor(values?: Partial<RowEdiCrossReferenceOrderTypeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiCrossReferenceOrderTypeFields {
	company_id: string;
	edi_code: string;
	equipment_type_id: string;
	fgi_packaging_type_code: string;
	hdr_uid: number;
	id: string;
	la_business_unit: string;
	"order_type.company_id": string;
	"order_type.descr": string;
	"order_type.id": string;
	"order_type.is_active": string;
	"order_type.order_mode": string;
	"order_type.planning_color": number;
	order_type_id: string;
	partner_id: string;
	revenue_code_id: string;
	seg_alloc_code: string;
	version: string;
}

